<template>

  <div>
    <div class="error input-error" v-if="hasError">{{currentErrorMessage}}</div>
    <div class="input text-input" @click="focusRef" :class="hasValue">
      <input
        type="password"
        :class="{inputClass, noIcons: !haveIcon}"
        ref="input"
        autocomplete="new"
        :placeholder="placeholderAsProp"
        :value="content"
        @input="updateValue($event.target.value)"
        v-on:keydown="handleKeyDown"
        v-on:keypress="handleKeyPress"
      />
<!--
      <span class="input&#45;&#45;placeholder" v-if="hasPlaceholder">{{placeholderAsProp}}</span>
-->
    </div>
  </div>

</template>

<script>
  import baseInput from './mixins/input.class';
  import {
    checkPasswordMaxLength,
    checkPasswordMinLength, checkPasswordStrenth,
    PASSWORD_MAX_LENGTH,
    PASSWORD_MIN_LENGTH
  } from "../helpers/field-checker.helper";
  import {F_ERR_ENUM} from "../enum/field-error.enum";

  export default {
    props: {
      haveIcon: {
        type: Boolean,
        default: false
      },
      usePasswordChecker: {
        type: Boolean,
        default: false
      },
      usePasswordStrengthDisplay: {
        type: Boolean,
        default: false
      },
      shouldEqual: {
        type: String,
        default: null
      }, // for password check only, empty/undefined/null for disabling
    },
    extends: baseInput,
    name: "password-input",
    watch: {
      shouldEqual (o) {
        this.updateValue(this.content);
      }
    },
    methods: {
      computeErrors () {
        if ((typeof this.shouldEqual === 'string') && this.content !== this.shouldEqual) {
          this.setError(F_ERR_ENUM.INCORRECT, this.$t('password-input.invalidMismatch'));
          return;
        }
        if (this.usePasswordChecker) {
          if (!checkPasswordMinLength(this.content)) {
            this.setError(F_ERR_ENUM.INCORRECT, this.$t('password-input.invalidMin', PASSWORD_MIN_LENGTH));
            return;
          }
          if (!checkPasswordMaxLength(this.content)) {
            this.setError(F_ERR_ENUM.INCORRECT, this.$t('password-input.invalidMax', PASSWORD_MAX_LENGTH));
            return;
          }
          if (!checkPasswordStrenth(this.content)) {
            this.setError(F_ERR_ENUM.INCORRECT, this.$t('password-input.invalidStrength'));
            return;
          }
        }
        this.setError(F_ERR_ENUM.INCORRECT, null);
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/password-input.vue